module.exports = __webpack_public_path__ + "img/ETF.0de25912.png";